import React, { FC } from 'react';
import { useSelector } from 'react-redux';
import { charterSelector } from '../../../../../../../../store/reducers/charterSlice/charterSlice';
import { positionSelector } from '../../../../../../../../store/reducers/positionSlice/positionSlice';
import { DaysModeCharter } from '../../DaysModeCharter/DaysModeCharter';
import { DaysModePosition } from '../../DaysModePosition/DaysModePosition';

export const DaysModeStageChild = ({ childGuid }) => {
    const charters = useSelector(charterSelector.selectEntities);
    const positions = useSelector(positionSelector.selectEntities);

    const chartersGuids = useSelector(charterSelector.selectIds);

    const isCharter = chartersGuids.includes(childGuid);

    return (
        <>
            {isCharter ? (
                <DaysModeCharter charter={charters[childGuid]} />
            ) : (
                <DaysModePosition position={positions[childGuid]} />
            )}
        </>
    );
};
